import { PlayerCardStats } from "@/src/types/Embeds";
import { Team_NAMES } from "@/src/types/teams";
import { TeamLogos } from "@/src/utils/teams";

export function renderStats(stats: PlayerCardStats[]) {
  return (
    <>
      {stats.map(function (stat, index) {
        return (
          <div
            className="flex flex-col w-full h-full items-center justify-center"
            key={`${index}-stat`}
          >
            <h2 className="font-bold text-lg md:text-2xl">{stat.value}</h2>
            <p className="font-thin text-sm text-center whitespace-nowrap">
              {stat.description}
            </p>
          </div>
        );
      })}
    </>
  );
}

export function getTeamLogo(teamname: Team_NAMES) {
  return TeamLogos[teamname] ?? "";
}
